import React from 'react';
import { Box, Typography, Paper, Card, CardContent, Grid } from '@mui/material';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import CalendarViewWeekOutlinedIcon from '@mui/icons-material/CalendarViewWeekOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';

const useCards = [
  {
    icon: <AccessTimeOutlinedIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />,
    title: '15–20 minutes a day',
    desc: 'A gentle daily rhythm for steady progress.'
  },
  {
    icon: <CalendarViewWeekOutlinedIcon sx={{ fontSize: 40, color: 'custom.red', mb: 1 }} />,
    title: 'A few times a week',
    desc: 'Flexible for your schedule and energy.'
  },
  {
    icon: <ReplayOutlinedIcon sx={{ fontSize: 40, color: 'custom.blue', mb: 1 }} />,
    title: 'As a “reset” whenever you feel lost',
    desc: 'Return to CYJ whenever you need a fresh start.'
  },
];

const HowToUse = () => (
  <Box sx={{ bgcolor: 'custom.yellow', py: { xs: 4, md: 6 }, px: { xs: 1, md: 0 } }}>
    <Paper elevation={2} sx={{ p: { xs: 3, md: 5 }, borderRadius: 2, bgcolor: 'white', maxWidth: 900, mx: 'auto' }}>
      <Typography variant="h2" sx={{ color: 'text.main', mb: 2, textAlign: 'center', fontFamily: 'Just Another Hand' }}>
        How to Use It (without pressure)
      </Typography>
      <Typography sx={{ color: 'text.secondary', mb: 2, textAlign: 'center', fontSize: { xs: 16, md: 18 } }}>
        You can use CYJ in whatever rhythm fits your life:
      </Typography>
      <Grid container spacing={3} justifyContent="center" sx={{ mb: 2 }}>
        {useCards.map((item, idx) => (
          <Grid item xs={12} sm={6} md={4} key={item.title}>
            <Card elevation={3} sx={{ borderRadius: 3, p: 2, height: '100%', bgcolor: 'background.paper', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>{item.icon}</Box>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>{item.title}</Typography>
                <Typography sx={{ color: 'text.secondary', fontSize: 15 }}>{item.desc}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Typography sx={{ color: 'text.secondary', mb: 2, textAlign: 'center' }}>
        There’s no rushing.<br />
        Your transformation isn’t a race.
      </Typography>
    </Paper>
  </Box>
);

export default HowToUse;
